<template>
  <div class="card flex1">
    <div class="top">
      <img class="profile" :src="info?.avatar_large || require('../../../../../assets/profile.png')
        " alt="" @click="changeInfoShow" />
      <img v-if="info?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png" alt="VIP" />
      <div v-if="!platformUserDetail" :class="['status', info.is_online ? '' : 'checkStatus']"></div>
    </div>
    <div class="info flex1 shrink0">
      <div class="name line-1">
        <div class="name-text line-1 flex row middle">
          <!-- <img :class="'w-20 h-20 mr-4 ' + (info?.confirmed ? '' : 'img_gray')" src="@/assets/confirmed.png"
                        alt=""> -->
          {{ info?.name || 'XXX' }}
        </div>
        <!-- <template>
          <el-popover placement="bottom" width="360" v-model="visible" trigger="hover">
            <p>当前心情：</p>
            <div class="moodListBox" style="margin-top: 10px;">
              <div class="moodImgBBox" v-for="(v, i) in mood" :key="i" @click="userDetail ? '' : setMoodFun(v)">
                <div :class="['moodImgBox', userDetail ? 'not-allowed' : 'pointer']" :style="'border-color:' + v.color">
                  <el-image style="width: 30px;" :src="v.img" fit="contain"></el-image>
                </div>
                <div :style="'color:' + v.color">{{ v.text }}</div>
              </div>
            </div>
            <div slot="reference">
              <template v-for="(v, i) in mood" v-if="v.key == info.mood">
                <div class="br-20 flex row middle center w-16 h-16 shrink0 pointer"
                  :style="'border: 1px solid ' + v.color">
                  <img class="like shrink0" :src="v.img" alt="">
                </div>
              </template>
<template v-if="!info.mood || info.mood == 'unknown'">
                <div class="br-20 flex row middle center w-14 h-14 shrink0 pointer">
                  <img class="w100 h100 shrink0" src="@/assets/heart.png" alt="">
                </div>
              </template>
</div>
</el-popover>
</template> -->
        <!-- <template v-else>
          <img class="like shrink0" src="@/assets/heart.png" alt="">
        </template> -->
      </div>
      <div class="phone line-1">
        <span v-if="userMood" class="mood-tag">{{ userMood }}</span>
        {{ id }}
      </div>
    </div>
    <!-- v-if="!platformUserDetail"  -->
    <img :class="['edit-icon', { 'has-notes': hasNotes }]" :src="hasNotes ? notebookActiveIcon : notebookIcon"
      @click="openDialog" alt="备忘录" />

    <!-- 备注弹窗 -->
    <NoteDialog :visible.sync="dialogShow" :chatUserInfo="chatUserInfo" :checkUser="checkUser"
      @note-changed="handleNoteChanged" />
  </div>
</template>

<script>
import { moods } from '@/api/user';
import { chatNoteList } from '@/api/dialogue';
import NoteDialog from './NoteDialog.vue';
import notebookIcon from '@/assets/svg/Notebook.svg';
import notebookActiveIcon from '@/assets/svg/Notebook-1.svg';

export default {
  props: {
    // 自己
    platformUserDetail: {
      type: Object,
      default: () => { },
    },
    // 对方
    userDetail: {
      type: Object,
      default: () => { },
    },
    id: {
      type: [String, Number],
      default: '',
    },
    userMood: {
      type: String,
      default: '',
    },
    isRightCard: {
      type: Boolean,
      default: false,
    },
    chatUserInfo: {
      type: Object,
      default: () => ({}),
    },
    historyList: {
      type: Array,
      default: () => [],
    },
  },
  emits: [],
  components: {
    NoteDialog,
  },
  data() {
    return {
      mood: [
        {
          img: require('@/assets/icon/bored.png'),
          key: 'bored',
          text: 'Serious',
          color: '#9FE9DC',
        },
        {
          img: require('@/assets/icon/friendly.png'),
          key: 'friendly',
          text: 'Pen pal',
          color: '#F0E392',
        },
        {
          img: require('@/assets/icon/romantic.png'),
          key: 'romantic',
          text: 'Romantic',
          color: '#FCB7AD',
        },
        {
          img: require('@/assets/icon/flirty.png'),
          key: 'flirty',
          text: 'Flirty',
          color: '#F89AA8',
        },
        {
          img: require('@/assets/icon/naughty.png'),
          key: 'naughty',
          text: 'Naughty',
          color: '#F9A596',
        },
      ],
      visible: false,
      dialogShow: false, // 备忘录弹窗状态
      infoShow: false, // 用户信息弹窗状态
      checkUser: 0, // 点击的是哪个备忘录 0自己 1对方
      noteCount: 0, // 备注数量
      notebookIcon,
      notebookActiveIcon,
    };
  },
  computed: {
    info() {
      if (this.platformUserDetail) {
        return this.platformUserDetail;
      } else {
        return this.userDetail;
      }
    },
    hasNotes() {
      return this.noteCount > 0;
    },
  },
  watch: {
    // 监听聊天对象信息变化，切换聊天对象时重新获取备注数量
    chatUserInfo: {
      handler(newVal, oldVal) {
        // 当聊天对象发生变化时，重新获取备注数量
        if (newVal && newVal.userId && newVal.platformUserId) {
          this.getNoteCount();
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    setMoodFun(v) {
      moods({
        platformUserId: this.platformUserDetail.platformUserId,
        platformType: this.platformUserDetail.platformType,
        mood: v.key,
      })
        .then((res) => {
          console.log(res, 'res');
          if (res.code == 200) {
            // this.$message.success('设置成功')
            this.platformUserDetail.mood = v.key;
            this.visible = false;
            this.$message.success('心情修改成功');
            // 内部处理心情更新逻辑
            this.refreshMood(v.key);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err, 'err');
        });
    },
    refreshMood(v) {
      console.log('心情改变:', v);
      console.log('右侧对话', this.historyList);
      // 心情改变时，更新本地所有对话的心情
      this.historyList.forEach((item) => {
        item.platformUserDetail.mood = v;
      });
      // 通过父组件调用其他组件的方法
      this.$parent.$refs.unreadMessageDom?.changeMood(v);
      // 通知子组件更新心情
      this.$parent.$refs.newMessagePanel?.updateMood(v);
    },
    openDialog() {
      if (!this.dialogShow) {
        // 设置用户类型
        this.checkUser = this.platformUserDetail ? 0 : 1;
        this.dialogShow = true;
      }
    },

    changeInfoShow() {
      // console.log(
      //   'card组件 changeInfoShow - id:',
      //   this.id,
      //   'isRightCard:',
      //   this.isRightCard
      // );
      this.infoShow = true;
      // 调用父组件的用户信息组件
      this.$parent.$refs.userInfoDom?.init(this.id, this.isRightCard);
    },
    // 生成聊天ID
    generateChatId() {
      if (!this.isRightCard) {
        return (
          this.chatUserInfo.userId + '-' + this.chatUserInfo.platformUserId
        );
      } else {
        return (
          this.chatUserInfo.platformUserId + '-' + this.chatUserInfo.userId
        );
      }
    },
    // 获取备注数量
    async getNoteCount() {
      try {
        const chatId = this.generateChatId();
        const res = await chatNoteList(chatId);
        if (res.code === 200) {
          console.log('获取备注数量', this.isRightCard, chatId);
          this.noteCount = res.data ? res.data.length : 0;
        } else {
          this.noteCount = 0;
        }
      } catch (error) {
        this.noteCount = 0;
      }
    },
    // 处理备注变更事件
    handleNoteChanged() {
      console.log('收到备注变更事件，重新获取备注数量');
      // 备注变更后重新获取备注数量，添加小延迟确保API数据已更新
      setTimeout(() => {
        this.getNoteCount();
      }, 500);
    },
    // 刷新备注数量（公共方法，可供外部调用）
    refreshNoteCount() {
      this.getNoteCount();
    },
  },
  created() { },
  mounted() {
    // 组件挂载时获取备注数量
    this.getNoteCount();
  },
};
</script>
<style lang="scss" scoped>
.card {
  // height: 60px;
  box-sizing: border-box;
  padding: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  margin-right: 18px;

  .top {
    position: relative;

    .status {
      position: absolute;
      bottom: 0%;
      right: 10%;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #0cd85d;
    }

    .checkStatus {
      background-color: #e5e5e5;
    }

    .crown-icon {
      position: absolute;
      top: -4px;
      right: 0;
      width: 16px;
      height: 16px;
      z-index: 10;
    }
  }

  .profile {
    width: 44px;
    height: 44px;
    margin-right: 6px;
    border-radius: 8px;
    cursor: pointer;
  }

  .info {
    // width: 80%;
    display: flex;
    flex-direction: column;

    .name {
      display: flex;
      align-items: center;

      .name-text {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        margin-right: 6px;
      }

      .like {
        width: 12px;
        height: 12px;
      }
    }

    .phone {
      font-size: 12px;
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }

  .edit-icon {
    width: 28px;
    height: auto;
    cursor: pointer;
    transition: opacity 0.3s ease;
  }
}

.moodListBox {
  width: 360px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .moodImgBBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .moodImgBox {
      width: 60px;
      height: 60px;
      border: 1px solid #000;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }

  .moodImgBBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .moodImgBox {
      width: 60px;
      height: 60px;
      border: 1px solid #000;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

.img_gray {
  filter: grayscale(100%) contrast(80%) brightness(110%);
}

.mood-tag {
  display: inline-block;
  padding: 2px 6px;
  margin-right: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
</style>
